import {Component, OnInit} from '@angular/core';
import {Participant} from '../../model/Participant';
import {SpeakersService} from '../../service/speakers.service';
import {AlertService} from '../../alert/alert.service';
import {Constants} from '../../model/Constants';

@Component({
  selector: 'app-plenary-speakers',
  templateUrl: './plenary-speakers.component.html',
  styleUrls: ['./plenary-speakers.component.css']
})
export class PlenarySpeakersComponent implements OnInit {

  errorService = false;

  constructor(private speakersService: SpeakersService,
              private alertService: AlertService) {
  }

  participants: Participant[];


  ngOnInit() {
    this.loadSpeakers();
  }

  loadSpeakers() {
    this.participants = this.speakersService.getSpeakers();
    this.participants.sort(function (a, b) {
      return a.lastName.localeCompare(b.lastName);
    });
    }

  private errorRegistration(err) {
    console.log(err);
    this.alertService.error(err);
  }
}




// WEBPACK FOOTER //
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/main/plenary-speakers/plenary-speakers.component.ts